import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchMember = createAsyncThunk(
    'user/fetchMember',
    async (query) => {
        try {
            const response = await myAxios.get(`/admin/list`);
            return { success: true, message: "Member fetched successfully!", data: response?.data?.list  };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const createMember = createAsyncThunk(
    'masters/createMember',
    async (formData) => {
        
        try {
            const response = await myAxios.post(`/admin/register`,  formData);

            return { success: true, message: "Member added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateMember = createAsyncThunk(
    'masters/updateMember',
    async (formData) => {
        try {
            const response = await myAxios.put(`/admin/update`, formData);

            return { success: true, message: "Member updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteMember = createAsyncThunk(
    'masters/deleteMember',
    async (query) => {
        try {
            const response = await myAxios.delete(`/admin/delete-user?userToDelete=${query?.userToDelete}`);

            return { success: true, message: "Member deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

const memberSlice = createSlice({
    name: 'member',
    initialState,
    reducers: {
        clearMemberData: state => {
            state.data = [];
        },
        setMemberData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const memberReducer = memberSlice.reducer;
export const { clearMemberData, setMemberData } = memberSlice.actions;

export const selectMemberData = (state) => state.member.data;
